import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-workspace-create-dialog',
  templateUrl: './workspace-create-dialog.component.html',
  standalone: false,
})
export class WorkspaceCreateDialogComponent {
  nameControl = new FormControl('', [Validators.required, Validators.minLength(4)]);

  constructor(public dialogRef: MatDialogRef<WorkspaceCreateDialogComponent>) {}

  submit(value: string): void {
    this.dialogRef.close(value);
  }
}
